import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-details-item',
  template: `
    @if (value) {
      <li>
        <p>
          <span>{{ title }}</span>
          <small>{{ value }} {{ unit }}</small>
        </p>
      </li>
    }
  `,
  styles: `
    @import 'src/theme/variables';
    li {
      padding-bottom: 20px;

      p {
        font-family: $font-en-primary;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.5px;

        span {
          font-size: 14px;
          font-weight: 600;
          color: #4c4c4c;
          margin-right: 8px;
        }

        small {
          font-weight: 400;
          font-size: 15px;
          color: $text-color-two;
        }
      }
    }
  `,
  standalone: true,
})
export class AdvertDetailsListItemComponent {
  @Input({ required: true }) value?: string | number;
  @Input({ required: true }) title!: string;
  @Input() unit?: string;
}
